import { useNavigate } from 'react-router'

export function useNavigateBack(fallbackPath) {
  const navigate = useNavigate()

  function navigateBack() {
    const hasPreviousPage = Number(window.history.state?.idx) > 0

    if (hasPreviousPage) {
      navigate(-1)
    } else {
      navigate(fallbackPath)
    }
  }

  return navigateBack
}
